// extracted by mini-css-extract-plugin
export default {"btnWrapper":"CreateForm_btnWrapper__T70Pu","addPreceptor":"CreateForm_addPreceptor__mhGvM"};